import styled from 'styled-components';

const ProgressContainer = styled.div`
	width: 100%;
	padding: 15px 0px;
	.progress__title {
		text-align: left;
		color: #ffffff;
		font-size: 10px;
		font-weight: 900;
		padding-bottom: 5px;
	}

	.MuiLinearProgress-barColorPrimary {
		background-color: ${props => props.theme.label.color};
	}
	.MuiLinearProgress-colorPrimary {
		background-color: #252525;
	}
`;

export default ProgressContainer;
